<template>
    <edit-view-base :filter="filter" :has-card-view="false" :cards="cards" :tabs="tabs" :main-form="mainForm" :claim-name="claimName" :api-method="apiMethod" :item-id="itemId" :refresh-key="refreshKey">
        <template v-slot:firstTab="{}">
            <v-tab @click="load()">Site History</v-tab>
            <v-tab-item>
                <v-row>
                    <v-col>
                        <v-text-field v-model="search" append-icon="mdi-search" label="Search" single-line hide-details />
                    </v-col>
                    <v-col>
                        <v-btn color="quaternary" dark class="ml-2 mb-2 float-right" v-on:click="download()">Export to Excel</v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-data-table :footer-props="footerProps" :headers="headers" :items="computedItems" :loading="loading" item-key="id">
                            <template v-for="header in headers" v-slot:[getSlotName(header.value)]="{ item }">
                                <table-item-display :header="header" :item="item" :key="header.title" />
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-tab-item>
        </template>
    </edit-view-base>
</template>

<script>
    import axios from 'axios'
    import exporter from '../export/exporter'
    export default {
        props: [
            'filter',
            'itemId',
            'refreshKey'
        ],

        components: {
            editViewBase: () => import('../components/EditViewBase'),
            tableItemDisplay: () => import('../components/TableItemDisplay')
        },

        data() {
            return {
                cards: [
                    { title: 'Site', apiMethod: 'Sites', form: () => import('../forms/SiteForm'), items: [], filter: {}, dialog: false, isVisible: true, isMainCard: true },
                    { title: 'Site Floral Variety', apiMethod: 'SiteFloralVarieties', parentForeignKey: 'siteId', form: () => import('../forms/SiteFloralVarietyForm'), items: [], filter: {}, dialog: false, isVisible: true },
                    { title: 'Site Treatment', apiMethod: 'SiteTreatments', parentForeignKey: 'siteId', form: () => import('../forms/SiteTreatmentForm'), items: [], filter: {}, dialog: false, isVisible: true },
                ],
                tabs: [
                    { text: 'Floral Varieties', value: 'siteId', isCard: true, table: () => import('../tables/SiteFloralVarietiesTable') },
                    { text: 'Load Movement From Sites', value: 'fromSiteId', table: () => import('../tables/LoadMovementsTable') },
                    { text: 'Load Movement To Sites', value: 'toSiteId', table: () => import('../tables/LoadMovementsTable') },
                    { text: 'Treatments', value: 'siteId', isCard: true, table: () => import('../tables/SiteTreatmentsTable') },
                ],

                headers: [
                    { text: 'Type', value: 'type' },
                    { text: 'Event', value: 'event' },
                    { text: 'On', value: 'on', format: this.formatDateTime }
                ],
                items: [],

                mainForm: () => import('../forms/SiteForm'),
                claimName: 'Sites',
                apiMethod: 'Sites',
                footerProps: { 'items-per-page-options': [15, 30, 50, 100] },
                loading: false,
                id: null,
                search: ""
            }
        },

        mounted() {
            if (this.itemId !== null && typeof (this.itemId) !== "undefined") {
                this.id = this.itemId;
            }
            else {
                this.id = this.$route.params.id;
            }
        },

        methods: {
            async load() {
                this.loading = true;
                try {
                    var response = await axios.get('/api/SiteHistory/' + this.id);
                    this.items = response.data;
                }
                finally {
                    this.loading = false;
                }
            },
            getSlotName(value) {
                return "item." + value;
            },

            download() {
                if (!this.computedItems || this.computedItems.length === 0) {
                    return;
                }
                var self = this;
                var items = this.computedItems.map(i => {
                    var row = {};
                    this.headers
                        .filter(e => e.text !== '')
                        .forEach(e => {
                            if (!e.hasOwnProperty('table')) {
                                row[e.text] = i[e.value];
                            }
                            else {
                                row[e.text] = self.computedItems[i[e.value]];
                            }
                        });
                    return row;
                });

                exporter.downloadAsExcel({ title: "Site History", items });
            },

            itemMatches(item, tokens) {
                for (var i = 0; i < tokens.length; i++) {
                    var token = tokens[i];
                    var isMatch =
                        this.includes(item.name, token) ||
                        this.includes(item.externalId, token);

                    if (!isMatch) {
                        return false;
                    }
                }
                return true;
            },

            includes(value, token) {
                if (!value) {
                    return false;
                }

                return ('' + value).toLowerCase().includes(token);
            }
        },
        computed: {
            computedItems() {
                var search = this.search;
                var tokens = search.toLowerCase().trim().split(' ');
                if (tokens.length < 1 || tokens[0].length === 0) {
                    return this.items;
                }

                return this.items.filter(i => this.itemMatches(i, tokens));
            }
        },
        watch: {
            id: {
                handler() {
                    this.load();
                }
            }
        }
    };
</script>
